import { Response } from '@src/interface/api/response.interface'
import client from '@src/lib/api/client'

export interface UploadFileResponse extends Response {
	data: {
		upload_results: { file_name: string; path: string }[]
	}
}

export const uploadFile = async (formData: FormData): Promise<UploadFileResponse> => {
	const response = await client.post<UploadFileResponse>(`/files`, formData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	})

	return response.data
}
